import { Music4, PenLine, CalendarRange } from "lucide-react";
import { Layout } from "./LegalPage";
import { getLang } from "../i18n";

const copy = {
  it: {
    title: "Chi è Abacico (?)",
    updated: "Il compositore di Universe",
    p1a: "È un compositore italiano e pianista alla ricerca continua del suo essere più profondo, che vuole rimanere ",
    anon: "anonimo",
    p1b: ".",
    p2a: "Attualmente lavora a tempo pieno al progetto USTP, unitamente alla scrittura di nuovi brani.",
    med: "",
    p2b: "",
    p3a: "In realtà ci dice che ",
    p3strong: "5 di questi brani li ha già scritti",
    p3b: " e ce li farà avere man mano che terminerà le fasi della produzione.",
    p4: "Abacico è veramente felice del progetto USTP e sta lavorando in modo rilassato e sereno, spesso in mare e fuori dai centri abitati, al fine di produrre delle nuove musiche - fratelli siamesi di Universe - che siano all'altezza delle aspettative del Team e che possano emozionare tutti i simpatizzanti e i Pionieri di USTP. Tuttavia talvolta è un po' preoccupato e si rattrista per la situazione geopolitica globale, con il rischio di nuove guerre e quelle attuali già in corso.",
    p5: "Confida che il progetto USTP possa contribuire in qualsiasi modo, sia pure in minima parte, affinché le cose cambino presto e che gli uomini che governano gli Stati intraprendano più azioni e vie diplomatiche costruttive per una inversione di questa brutta tendenza che attualmente si basa su una economia di guerra, soprattutto in Europa, che purtroppo sembra non promettere nulla di buono.",
    team: "Il Team",
    stats: ["fratelli siamesi di Universe", "brani già scritti", "orizzonte di produzione"],
  },
  en: {
    title: "Who is Abacico (?)",
    updated: "The composer of Universe",
    p1a: "He is an Italian composer and pianist on a continuous search for his deepest self, who wishes to remain ",
    anon: "anonymous",
    p1b: ".",
    p2a: "He currently works full-time on the USTP project, together with writing new tracks.",
    med: "",
    p2b: "",
    p3a: "In fact he tells us that ",
    p3strong: "he has already written 5 of these pieces",
    p3b: " and will deliver them as he completes the production phases.",
    p4: "Abacico is truly happy about the USTP project and is working in a relaxed and serene way, often at sea and away from inhabited areas, in order to produce new music - siamese brothers of Universe - that lives up to the Team's expectations and can move all USTP supporters and Pioneers. However, at times he is a little worried and saddened by the global geopolitical situation, with the risk of new wars and those already ongoing.",
    p5: "He trusts that the USTP project can contribute in any way, even to a minimal extent, so that things change soon and that the men who govern the States undertake more constructive diplomatic actions and paths to reverse this ugly trend currently based on a war economy, especially in Europe, which unfortunately seems to promise nothing good.",
    team: "The Team",
    stats: ["siamese brothers of Universe", "pieces already written", "production horizon"],
  },
};

export default function AbacicoPage() {
  const t = copy[getLang()];
  const stats = [
    { icon: Music4, v: "15", l: t.stats[0] },
    { icon: PenLine, v: "5", l: t.stats[1] },
    { icon: CalendarRange, v: "2026–2029", l: t.stats[2] },
  ];
  return (
    <Layout title={t.title} updated={t.updated}>
      <p>
        {t.p1a}
        <strong>{t.anon}</strong>
        {t.p1b}
      </p>
      <p>
        {t.p2a}
        <strong>{t.med}</strong>
        {t.p2b}
      </p>
      <p>
        {t.p3a}
        <strong>{t.p3strong}</strong>
        {t.p3b}
      </p>
      <p>{t.p4}</p>
      <p>{t.p5}</p>

      <p className="border-t border-slate-100 pt-6 font-display font-bold text-slate-900">
        {t.team}
        <span className="block font-mono text-xs font-normal tracking-[0.18em] text-slate-500 mt-1">
          USTP - UNIVERSE SCORE TOKEN PROTOCOL
        </span>
      </p>

      <div className="grid grid-cols-3 gap-3 not-italic">
        {stats.map((s) => (
          <div key={s.l} className="rounded-2xl border border-sky-100 bg-sky-50/70 px-3 py-4 text-center">
            <s.icon size={18} className="mx-auto text-sky-600" />
            <p className="mt-1.5 font-mono text-lg font-bold text-slate-900">{s.v}</p>
            <p className="text-[11px] text-slate-500 leading-tight">{s.l}</p>
          </div>
        ))}
      </div>
    </Layout>
  );
}
